import { Flags, ValueOfKey } from '../../../utils-types';

export const BILLING_TYPE = {
  AUTOMATED_BILLING: 'AUTOMATED_BILLING',
  SELF_BILLING: 'SELF_BILLING',
} as const;

export type BillingType = ValueOfKey<typeof BILLING_TYPE>;
export type BillingTypeKey = keyof typeof BILLING_TYPE;
export type BillingTypeFlags = Flags<BillingTypeKey>;
